import introImg from '../../../../assets/images/courses/teamplayer&collaboration/chapter2.1.jpg';
import chapterImg1 from '../../../../assets/images/courses/teamplayer&collaboration/chapter2.2.jpg';
import { CourseChapter } from '../../../../courses/courses.types';
import { JigSawModule } from '../../JigSawModule';
import { MediaBlock } from '../../MediaBlock';

interface TeamPlayersAndCollaborationChapter1 {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const TeamPlayersAndCollaborationChapter2: React.FC<TeamPlayersAndCollaborationChapter1> = ({
  chapter,
  onNextChapter,
  totalPages,
}) => {
  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };

  const boxes = [
    {
      id: '1',
      title: 'Lean into Listen',
      content:
        'Stop everything and be fully present. Lean in slightly to show interest, and if we`re virtual, simulate eye contact by looking at the camera.',
      color: '#54a503', //green
    },
    {
      id: '2',
      title: 'Open Posture',
      content:
        'Keep your arms and palms exposed and relaxed. Crossed arms and legs can convey defensiveness or disinterest, so keep it open, unless the context suggests otherwise.',
      color: '#1f497d', //blue
    },
    {
      id: '3',
      title: 'Validate',
      content:
        "Clarify and reflect on what you've heard. Ask follow-up questions for more information and paraphrase what you understand in your own words.",
      color: '#c00000', //red
    },
    {
      id: '4',
      title: 'Elevate',
      content:
        'Your attitude and behavior influence the team´s mood, so aim to consciously elevate the vibe. It´s not about faking it but recognizing that we can shift our attitude to positively impact those around us.',
      color: '#ffc000', //yellow
    },
  ];

  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Engage Fully</h2>

        <MediaBlock mediaImage={introImg}></MediaBlock>
        <br />

        <p className="text-lg font-normal text-center mt-7 mb-20 leading-10">
          If we were chatting at work and I kept glancing at my phone, you might feel somewhat
          undervalued, like I'm not fully focused on our conversation. It's those little unconscious
          actions that can affect important work and personal relationships.
        </p>
        <p className="text-lg font-bold text-center mt-7 mb-20 leading-10">
          Listening attentively and making team members feel heard is crucial for building trust and
          synergy.{' '}
        </p>
        <br />
        <h3 className="text-2xl text-purple-600 font-bold mt-10 mb-1">
          Power of the LOVE Framework
        </h3>
        <p className="text-lg font-normal text-left mt-7 mb-20 leading-10">
          Here's a simple framework to help you stay engaged with your team members, <br />
          just remember to show the LOVE: <br />
          Click each segment below to learn more.
        </p>
        <JigSawModule backgroundColor="#f3f4f6" boxes={boxes} />
        <br />
        <div className="md:flex items-center mb-7">
          <p className="flex-1 leading-7">
            <br />
            <strong>Here's an example. </strong>
            <br />
            Marilyn Monroe was once strolling in downtown New York City with a friend who expressed
            astonishment at her ability to maintain anonymity in public. Marilyn replied, "That's
            because I'm walking as Norma Jean. If I walked as Marilyn, everyone would notice me."
            Her friend, disbelieving, encouraged her to show her what she meant. Instantly, Norma
            Jean transformed herself into Marilyn Monroe, the movie star. She radiated a certain
            energy and within minutes she was surrounded by fans.
          </p>
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg1} alt="" />
          </div>
        </div>

        <p className="text-lg font-bold text-left mt-7 mb-7 leading-10">
          By showing the LOVE and being mindful of how you engage with your teammates, you can
          foster stronger relationships and create a more positive and productive team.
        </p>
        <p className="text-lg font-bold text-left mt-7 mb-10 leading-10">
          Remember: how you consistently show up to your team affects how they respond, feel, and
          perform. <br />
        </p>

        <button onClick={handleNextChapterClick} className="btn-internal w-full">
          Manage Expectations & Foster Trust
        </button>
      </div>
    </>
  );
};
